module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.flowsEmpty()) ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadFlows),
      expression: "loadFlows"
    }],
    staticClass: "table",
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "table-actions light-gray"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters,
      "options": _vm.filter_options
    },
    on: {
      "filter": _vm.filter
    }
  })], 1), _c('div', {
    staticClass: "table-body",
    attrs: {
      "id": "flows-list"
    }
  }, _vm._l((_vm.flows), function(flow) {
    return _c('flow-list-item', {
      key: flow.id,
      attrs: {
        "flow": flow,
        "options": _vm.list_item_options
      },
      on: {
        "flow-update": _vm.updateFlow,
        "flow-confirm-destroy": _vm.openDestroyFlowConfirmationModal
      }
    })
  }), 1), _c('br'), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noDataText')))])], 1), _c('confirm-modal', {
    attrs: {
      "id": "destroy-flow-confirmation-modal",
      "title": _vm.$t('flows.label.removeCadenceFlowConfirm'),
      "message": _vm.destroy_confirm_modal_message,
      "confirm_text": _vm.$t('general.label.yes'),
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.destroyFlow
    }
  }), _c('go-to-top')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a2cfdf4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/list.vue
// module id = 1175
// module chunks = 1